import React, { useEffect, useState } from 'react'
import { View } from 'react-native'
import { color } from '../../theme'
import { Text } from '../text'
import StepIndicator from 'react-native-step-indicator'

const CustomLabel = (props: { title: string }) => {
  const { title } = props
  return (
    <View style={{ paddingTop: 15 }}>
      <Text
        style={{ fontSize: 12, textAlign: 'center', fontWeight: '600', color: color.palette.white }}
      >
        {title}
      </Text>
    </View>
  )
}

export const StepIndicatorWizard = (props: any) => {
  const { stepCount, labels, customStyles, setValue, defaultValue, rangeResponse } = props
  const [currentPosition, setCurrentPosition] = useState<number>()
  const onPageChange = (position: number) => {
    setCurrentPosition(position)
    setValue(position + 1) // +1 -> first Index: 0
  }

  useEffect(() => {
    //force to clear initial value
    setCurrentPosition(defaultValue)
  }, [])
  return (
    <StepIndicator
      stepCount={stepCount}
      onPress={onPageChange}
      customStyles={customStyles}
      currentPosition={rangeResponse ? rangeResponse - 1 : currentPosition}
      labels={labels}
      renderLabel={({ position = 0 }) => {
        if (position === 0) {
          return <CustomLabel title={labels[0] ?? 'Like'} />
        } else if (position == 4) {
          return <CustomLabel title={labels[4] ?? 'Dislike'} />
        }
      }}
    />
  )
}
